@if (team$ | async; as team) {
    @let childTeams = (childTeams$ | async) ?? [];
    @let childTeamCount = (allChildTeamCount$ | async) ?? 0;

    <div [ngClass]="{'standard-font-weight': !showIcon, 'has-children': showChildren && childTeams.length > 0}">
        <div class="align-items-baseline d-flex flex-grow-1">
            <div class="d-flex flex-wrap align-items-center gap-2">
                <div class="align-items-baseline d-flex team-icon-name-container">
                    @if (showIcon) {
                        <span [adaptTooltip]="showIconTooltip ? ((iconTooltip$ | async)!) : ''"
                              [adaptTooltipIsHtml]="true"
                              tooltipContentClasses="text-start"
                              [class.icon-border]="showIconBorder"
                              [class.small-icon]="smallIcon"
                              class="fa-layers team-icon">
                                <i class="fas fa-fw fa-inverse"
                                   [style.background-color]="iconColour$ | async"
                                   [ngClass]="icon$ | async"
                                   aria-hidden="true"></i>
                            @if (childTeamCount > 0 && shouldShowChildCount) {
                                <span class="fa-layers-counter">{{childTeamCount}}</span>
                            }
                        </span>
                    }

                    @if (showName) {
                        <a [routerLink]="dashboardUrl$ | async"
                           class="team-name"
                           [ngClass]="{'bold-font-weight': showIcon}">{{team.name}}</a>

                        <adapt-team-private-icon [team]="team"></adapt-team-private-icon>
                    }
                </div>

                @if (showLabels) {
                    <adapt-display-labels [linkDisabled]="labelLinkDisabled"
                                          [labelLocations]="team.labelLocations"></adapt-display-labels>
                }
            </div>

            @if (showChildren && childTeams.length > 0) {
                <span (click)="childrenExpanded = !childrenExpanded"
                      [adaptTooltip]="'Click to ' + (childrenExpanded ? 'hide' : 'show') + ' child teams'"
                      class="flex-grow-1 text-end me-2 expand-children"
                      data-test="expand-child-teams">
                    <i class="fa"
                       [ngClass]="childrenExpanded ? 'fa-chevron-up': 'fa-chevron-down'"></i>
                </span>
            }
        </div>

        @if (childrenExpanded && showChildren && childTeams.length > 0) {
            <div class="d-flex flex-column flex-grow-1 ms-2 me-0 expanded-children">
                @for (team of childTeams; track team.teamId) {
                    <adapt-link-team [team]="team"
                                     [showIcon]="true"
                                     [showLabels]="showLabels"
                                     [showChildren]="showAllChildren"
                                     [showAllChildren]="showAllChildren"
                                     [filterTeams]="filterTeams"
                                     class="mt-1"></adapt-link-team>

                }
            </div>
        }
    </div>
}

@if (showTeamLeaderIcon$ | async) {
    <span class="fa-stack team-leader-icon"
          [adaptTooltip]="teamLeaderLabel$ | async">
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fal fa-star fa-stack-1x fa-inverse"></i>
    </span>
}
